import { createFileRoute } from "@tanstack/react-router"
import { StandardStorePage } from "@/features/standard-store/components/StandardStorePage"
import { standardStorePageQuery } from "@/features/standard-store/hooks/useStandardStoreBaseline"

export const Route = createFileRoute("/(authenticated)/settings/standard-store/")({
  loader: ({ context }) => {
    void context.queryClient.ensureQueryData(standardStorePageQuery())
  },
  component: StandardStorePage,
})
